import React from 'react';
import ReactDOM from 'react-dom';
import { IScript } from 'interfaces/IScript';
import { BaseComponent } from 'components/BaseComponent';

interface IProps {
  script: IScript;
}

export default class Analytics extends BaseComponent<{}, IProps> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    const script = document.createElement('script');

    script.innerHTML = `(function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
      }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
      ga('create', '${this.props.script.value}', 'auto', 'ClienteEduzz');
      ga('ClienteEduzz.send', 'pageview');
      console.log('Cliente Eduzz analytics', '${this.props.script.value}');`;

    ReactDOM.findDOMNode(this).appendChild(script);
  }

  render() {
    return (<div />);
  }
}


// WEBPACK FOOTER //
// ./src/components/Scripts/Analytics.tsx